// Import dependencies
import React from 'react';
import axios from 'axios';
import queryString from 'query-string';
import cookie from 'js-cookie';
import { tokenize } from '../../../../../helper';
import { displayUserAuthAuthorized, displayEmailVerified, displayAffiliateNumber, displayDeviceType } from '../../uiAdminHelpers';
import { FaUserCircle, FaCheck, FaTimes, FaStar } from 'react-icons/fa'

import AdminNavbar from '../../../../reusables/adminNavbar';
import './VideoAnalyticsDetailPage.css';

// Import config
import config from '../../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';
const VIDEO_API_URL = API_URL + '/video';

class VideoAnalyticsDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uri: 0,
            videoThumbnail: "",
            videoInfo: [],
            videoDetails: [],
            videoRatings: [],
            sortKey: 'IDDESC'
        }
    }

    componentDidMount() {
        console.log("HERE")
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }

        var { uri } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });


        if (!uri) {
            window.location.href = '/admin/analytics/ videos'
        } else {
            this.setState({ uri })
            setTimeout(this.queryVideoDetails, 100);
            setTimeout(this.queryVideoThumbnail, 10);
            setTimeout(this.queryVideoRatings, 10)
        }
    }

    queryVideoDetails = () => {
        setTimeout(this.queryMemberDetails, 100);
        setTimeout(this.queryVideoThumbnail, 10);
    }

    queryMemberDetails = () => {
        axios.get(`${SETTINGS_URL}/analytics/details?uri=${this.state.uri}&sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    var { result, newResult } = payload;
                    this.setState({ videoInfo: result, videoDetails: newResult[0] });
                } else {

                }
            })
            .catch(error => {

            })
    }

    queryVideoRatings = () => {
        axios.get(`${SETTINGS_URL}/analytics/video-ratings?uri=${this.state.uri}&sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    var { result } = payload;
                    this.setState({ videoRatings: result });
                } else {

                }
            })
            .catch(error => {

            })
    }

    queryVideoThumbnail = () => {
        this.setState({ loadingVideos: true })

        axios.get(`${VIDEO_API_URL}/single_video?video_id=${this.state.uri}`, tokenize())
            .then(response => {
                // console.log(response.data);

                if (response.data.success) {
                    console.log(response)
                    this.setState({
                        videoThumbnail: response.data.responseBody.pictures.sizes[1].link
                    });
                } else {
                    if (response.data.portfolioNotFound) {
                        console.log("Portolio not found")
                        this.setState({ error: true, errorCode: 'V1', errorMessage: 'Issue loading videos. Please log out and login again. If issues persists call OLLI at (949) 451-1403.' })
                    }
                }

            })
            .catch(error => {
                console.log(error);
                this.setState({ error: true });
            })
    }

    handleViewSortRequest = (type) => {
        switch (type) {
            case 'member':
                (this.state.sortKey === 'IDDESC') ? this.setState({ sortKey: 'IDASC' }) : this.setState({ sortKey: 'IDDESC' });
                break;
            case 'partial':
                (this.state.sortKey === 'PARTIALDESC') ? this.setState({ sortKey: 'PARTIALASC' }) : this.setState({ sortKey: 'PARTIALDESC' });
                break;
            case 'full':
                (this.state.sortKey === 'FULLDESC') ? this.setState({ sortKey: 'FULLASC' }) : this.setState({ sortKey: 'FULLDESC' });
                break;
            case 'date':
                (this.state.sortKey === 'DATEDESC') ? this.setState({ sortKey: 'DATEASC' }) : this.setState({ sortKey: 'DATEDESC' });
                break;
            default:
                this.setState({ sortKey: 'IDDESC' });
        }

        setTimeout(() => {
            this.queryMemberDetails()
        }, 100)
    }

    handleRatingSortRequest = (type) => {
        switch (type) {
            case 'member':
                (this.state.sortKey === 'IDDESC') ? this.setState({ sortKey: 'IDASC' }) : this.setState({ sortKey: 'IDDESC' });
                break;
            case 'rating':
                (this.state.sortKey === 'RATINGDESC') ? this.setState({ sortKey: 'RATINGASC' }) : this.setState({ sortKey: 'RATINGDESC' });
                break;
            case 'date':
                (this.state.sortKey === 'DATEDESC') ? this.setState({ sortKey: 'DATEASC' }) : this.setState({ sortKey: 'DATEDESC' });
                break;
            case 'updated':
                (this.state.sortKey === 'UPDATEDDESC') ? this.setState({ sortKey: 'UPDATEDASC' }) : this.setState({ sortKey: 'UPDATEDDESC' });
                break;
            default:
                this.setState({ sortKey: 'IDDESC' });
        }

        setTimeout(() => {
            this.queryVideoRatings();
        }, 100)
    }

    render() {
        return (
            <div>
                <AdminNavbar />

                <h1 className='pageTitle'>Detailed Video Analytics</h1>

                <div className='row adminPageSubHeader justify-content-start'>
                    <div className='col-4 text-center'>
                        {
                            this.state.videoThumbnail === "" ?
                                <div className="text-center">
                                    <div class="spinner-border text-center" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div> :
                                <img src={this.state.videoThumbnail} alt="video image" class="img-thumbnail" />
                        }
                    </div>
                    <div className='col-8'>
                        <div>Title: {this.state.videoDetails.title}</div>
                        <div>Partial Views: {this.state.videoDetails.partial_views}</div>
                        <div>Full Views: {this.state.videoDetails.full_views}</div>
                    </div>
                </div>

                <table className='table table-striped generalTable'>
                    <thead>
                        <tr>
                            <th onClick={() => this.handleViewSortRequest('member')}>Member</th>
                            <th onClick={() => this.handleViewSortRequest('partial')}>Partial View</th>
                            <th onClick={() => this.handleViewSortRequest('full')}>Full View</th>
                            <th onClick={() => this.handleViewSortRequest('date')}>Date Watched</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.videoInfo.map((entry, index) => {
                            var entryDateTime = new Date(entry.created_at).toLocaleString();

                            return <tr key={index}>
                                <td>{entry.name}</td>
                                <td>{entry.full_view === 0 ? <FaCheck color="green" /> : ""}</td>
                                <td>{entry.full_view === 1 ? <FaCheck color="green" /> : ""}</td>
                                <td>{entryDateTime}</td>
                            </tr>
                        })}
                    </tbody>

                </table>

                <h1 className='pageTitle'>Ratings</h1>

                <table className='table table-striped generalTable'>
                    <thead>
                        <tr>
                            <th onClick={() => this.handleRatingSortRequest('member')} >Member</th>
                            <th onClick={() => this.handleRatingSortRequest('rating')}>Rating</th>
                            <th onClick={() => this.handleRatingSortRequest('date')}>Date Rated</th>
                            <th onClick={() => this.handleRatingSortRequest('updated')}>Updated Rating</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.videoRatings.map((entry, index) => {
                            var entryDateTime = new Date(entry.created_at).toLocaleString();

                            return <tr key={index}>
                                <td>{entry.name}</td>
                                <td>
                                    {
                                        [...Array(entry.rating)].map((e, i) => <FaStar color="orange" textAnchor="0" />)
                                    }
                                </td>
                                <td>{entryDateTime}</td>
                                <td>{entry.updated === 1 ? <FaCheck color="green" /> : ''}</td>
                            </tr>
                        })}
                    </tbody>

                </table>

            </div>
        )
    }
}

export default VideoAnalyticsDetailPage;